import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BootstrapService {
  public initApplicationData(): Promise<void> {
    return Promise.resolve();
  }
}
